"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZES_INT = exports.SIZES = exports.AVATAR_FONT_SIZES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _theme = _interopRequireDefault(require("../Theme/lib/AirasiaClassic/theme"));

var _SIZES_INT, _AVATAR_FONT_SIZES;

var SIZES = {
  MEDIUM: 'medium',
  LARGE: 'large'
};
exports.SIZES = SIZES;
var SIZES_INT = (_SIZES_INT = {}, (0, _defineProperty2.default)(_SIZES_INT, SIZES.SMALL, 16), (0, _defineProperty2.default)(_SIZES_INT, SIZES.MEDIUM, 24), (0, _defineProperty2.default)(_SIZES_INT, SIZES.LARGE, 32), _SIZES_INT);
exports.SIZES_INT = SIZES_INT;
var AVATAR_FONT_SIZES = (_AVATAR_FONT_SIZES = {}, (0, _defineProperty2.default)(_AVATAR_FONT_SIZES, SIZES.MEDIUM, _theme.default.fontSize.XSmall), (0, _defineProperty2.default)(_AVATAR_FONT_SIZES, SIZES.LARGE, _theme.default.fontSize.small), _AVATAR_FONT_SIZES);
exports.AVATAR_FONT_SIZES = AVATAR_FONT_SIZES;